var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 18.8953C16.7392 18.8953 20.5809 15.0536 20.5809 10.3146C20.5809 5.57563 16.7392 1.73394 12.0002 1.73394C7.26123 1.73394 3.41954 5.57563 3.41954 10.3146C3.41954 15.0536 7.26123 18.8953 12.0002 18.8953Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16C15.3137 16 18 13.3137 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 13.3137 8.68629 16 12 16Z",
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2824 6H9.84473V14.6263H11.2824V6Z",
    fill: "#FAFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1579 6H12.7202V14.6263H14.1579V6Z",
    fill: "#FAFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.313 9.59201V8.1543H7.68672V9.59201H16.313Z",
    fill: "#FAFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.313 12.467V11.0293H7.68672V12.467H16.313Z",
    fill: "#FAFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 23.667L6.94835 18.417H17.052L12.0002 23.667Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMarker);
export default __webpack_public_path__ + "static/media/light-marker.e46d8272a9b0a7009d1518280f51bd28.svg";
export { ForwardRef as ReactComponent };